import { WandSparkles, FileJson, ImageIcon, LayoutTemplate, Video } from "lucide-react";
import ImageCreation from "./ImageCreation";
import MenuDataExtraction from "./MenuDataExtraction";
import ImageExtraction from "./ImageExtraction";
import BaseTemplateCreation from "./BaseTemplateCreation";
import VideoDownload from "./VideoDownload";

// Components that can be added to the Homepage Workflow from the Library.
// Adding one: build the card, register it here, and allow its type in
// Backend/controllers/imageGenerationController.js → WORKFLOW_TYPES.
const workflowRegistry = [
  {
    type: "image-creation",
    name: "Image Creation",
    description: "Create and edit menu images using AI",
    icon: WandSparkles,
    component: ImageCreation,
  },
  {
    type: "menu-data-extraction",
    name: "Menu Data Extraction",
    description: "Extract item title, price and description from a menu photo or PDF",
    icon: FileJson,
    component: MenuDataExtraction,
  },
  {
    type: "image-extraction",
    name: "Image Extraction",
    description: "Extract a product image from a PDF and place it on a clean white background",
    icon: ImageIcon,
    component: ImageExtraction,
  },
  {
    type: "base-template-creation",
    name: "Base Template Creation",
    description: "Save your branding and layout once, then reuse it for every image",
    icon: LayoutTemplate,
    component: BaseTemplateCreation,
  },
  {
    type: "video-download",
    name: "Video Download",
    description: "Download a video from a YouTube, Instagram or direct link and add it to a Mode",
    icon: Video,
    component: VideoDownload,
  },
];

export const getWorkflowEntry = (type) => workflowRegistry.find((c) => c.type === type);

export default workflowRegistry;
